<template>
	<div class="admin">
		<AdminMenu/>
		<div class="main-panel">
			<TopNav :createUserPage="createUserPage" />
			<div v-if="outages.length > 0" class="alert alert-danger fade show outage_banner">
				<ul class="list-inline outages_top_bar">
					<li><strong>Outages:</strong></li>
					<li v-for="(outage,index) in outages" :key="outage.url + '_' + index">
						{{outage.url}}
					</li>
				</ul>
			</div>
			<router-view></router-view>
		</div>
	</div>
</template>

<script>
import '../../assets/js/paper-dashboard.js'
import {db, messaging} from "@/firebase/init";
import {PerfectScrollbar} from 'vue2-perfect-scrollbar';

export default {
		name: "adminPage",
		data() {
			return {
				createUserPage: false,
        logRocketAccounts: ['justin@bigscoots.com', 'dean@bigscoots.com']
      };
		},
		computed: {
			outages(){
        let outages = this.$store.getters['notification/getAllOutages'];
        const testIps = ['69.162.173.212', '23.29.145.209']
        const activeJobIps = this.$store.getters['notification/getActiveJobIps'] || []
        outages = outages
            .filter(test => {
              // if((test.portal_version && test.portal_version === 'v2' && !(this.user.email === 'khan@bigscoots.com' || this.user.email === 'sara@bigscoots.com'))) return false
              if(testIps.includes(test.serverIP)) return false
              if(activeJobIps.includes(test.serverIP)) return false
              return true
        }).filter(el => !el.hbSuspended)
        if(this.user.email !== 'khan@bigscoots.com') {
          outages = outages.filter(el => el.serverIP !== '74.121.207.61')
        }
        return outages.filter(el => !el.type || el.type !== 'diskAlert');
			},
			user(){
				return this.$store.getters.user;
			},
			adminNotificationOn(){
				return this.$store.getters.isNotifications;
			}
		},
		components: {
			PerfectScrollbar,
			AdminMenu: () =>
				import(/* webpackChunkName: "adminMenu" */ "../../components/Admin/SideMenu.vue"),
			TopNav: () =>
				import(/* webpackChunkName: "topNav" */ "../../components/TopNav.vue")
		},
		beforeRouteUpdate(to, from, next) {
			this.createUserPage = !this.createUserPage;
			/*if (to.name === 'createUser') {
				this.createUserPage = true;
			}else{
				this.createUserPage = false;
			}*/
			next();
		},
    mounted() {
      console.log('Taking notification consent' , this.user);
      this.refreshFcmToken()
      // if (this.logRocketAccounts.includes(this.user.email)) {
        // Log rocket comented from here as it don't alow new sessions.
    //     LogRocket.init('avvfqv/bigscoots');
    //     LogRocket.identify(this.user.uid, {
    //       name: this.user.firstName + ' ' + this.user.lastName,
    //       email: this.user.email
    //     });
    //   // }
      // if(messaging !== null){
      //   Notification.requestPermission().then((permission) => {
      //     if (permission === 'granted') {
      //       messaging.getToken().then((currentToken) => {
      //         if (currentToken) {
      //           console.log(currentToken);
      //           this.registerAndSubscribeToken(currentToken);
      //         }
      //       });
      //       // Callback fired if Instance ID token is updated.
      //       messaging.onTokenRefresh(() => {
      //         messaging.getToken().then((refreshedToken) => {
      //           console.log('Token refreshed.');
      //           console.log(refreshedToken);
      //           this.registerAndSubscribeToken(refreshedToken);
      //         });
      //       });
      //     } else {
      //       console.log('Unable to get permission to notify.');
      //     }
      //   });
      // }
    },
    methods: {
			async registerAndSubscribeToken(token){
				await db.collection('users').doc(this.user.uid).update({fcmToken: token});
				if(this.adminNotificationOn){
					this.$http.post('/status_cake/subscribe_to_topic', {
						fcmToken: token
					}).then((resp) => {
						console.log(resp.data.msg);
					});
				}

			},
      async refreshFcmToken(){
        const {fcmToken} = this.user;
        const token = await messaging.getToken();
        if(fcmToken && !fcmToken.includes(token)) {
         fcmToken.push(token);
          await db.collection('users').doc(this.userUId).update({
            fcmToken: fcmToken
          })
        }
      },
		}
	};
</script>

<style lang="scss">
	.green-select {
		background-color: #30CB87;
		color: #f3f3f3;
		font-weight: bold;

		option {
			font-weight: bold;
		}
	}

	.red-select {
		background-color: #dc3545;
		color: #f3f3f3;
		font-weight: bold;

		option {
			font-weight: bold;
		}
	}
	.swal2-cancel{
		color: #000000 !important;
	}
	.outage_banner{
		margin: 0 30px 20px;
		top: 0;
		overflow: auto;
	}
	.outage_banner ul{
		display: inline-flex;
		margin-bottom: 0
	}
	.outage_banner ul li{
		margin-left: 10px
	}
</style>
